export const LABORATORY_TTL_ES = 'Laboratorios';
export interface ILaboratoryBase {
  description: string;
}
export interface ILaboratory extends ILaboratoryBase {
  id: number;
}
export type ILaboratoryUpdate = Partial<ILaboratoryBase>;
